import React, { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Tooltip } from "antd";
import CommonDeleteModal from "../CommonDelete&ActiveModal/CommonDeleteModal";
import loader from "../../methods/loader";
import Pagination from "react-pagination-js";
import { useSelector } from "react-redux";
import Layout2 from "../../components/global/layout2";

var statusOptions = [
  { value: "", label: "All Statuses" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "draft", label: "Draft" },
];

var AgreementTemplates = function () {
  var dataState = useState([]);
  var data = dataState[0];
  var setdata = dataState[1];

  var historyHook = useHistory();

  var totalState = useState(0);
  var total = totalState[0];
  var setTotal = totalState[1];

  var deleteModalState = useState("none");
  var ShowDeleteModal = deleteModalState[0];
  var setShowDeleteModal = deleteModalState[1];

  var deleteIdState = useState("");
  var DeleteId = deleteIdState[0];
  var setDeleteId = deleteIdState[1];

  var loaderrState = useState(false);
  var loaderr = loaderrState[0];
  var setLoaderr = loaderrState[1];

  var user = useSelector(function (state) { return state.user; });
  var searchState = useSelector(function (state) { return state.search; });

  var filtersState = useState({
    page: 1,
    count: 20,
    search: "",
    status: "",
  });
  var filters = filtersState[0];
  var setFilter = filtersState[1];

  var Delete = function () {
    Deletedata(DeleteId);
  };

  var ChangeFilter = function (e) {
    setFilter(e);
    Getdata(e);
  };

  var pageChange = function (e) {
    setFilter({ ...filters, page: e });
    Getdata({ page: e });
  };

  var Getdata = function (p) {
    if (!p) p = {};
    loader(true);
    setLoaderr(true);
    var filter = { ...filters, ...p };
    var params = {};
    Object.keys(filter).forEach(function (key) {
      if (filter[key] !== "" && filter[key] !== undefined) {
        params[key] = filter[key];
      }
    });
    ApiClient.get("carrier-agreement-templates", params).then(function (res) {
      if (res.success) {
        setdata(res?.data?.data || res?.data || []);
        setTotal(res?.data?.total_count || res?.data?.total || 0);
      }
      loader(false);
      setLoaderr(false);
    });
  };

  useEffect(function () {
    Getdata();
  }, []);

  useEffect(function () {
    if (user && user.loggedIn) {
      setFilter({ ...filters, search: searchState.data });
      Getdata({ search: searchState.data, page: 1 });
    }
  }, [searchState]);

  var Deletedata = function (id) {
    loader(true);
    ApiClient.delete("carrier-agreement-template", { id: id }).then(function (res) {
      if (res.success) {
        toast.success("Template deleted successfully");
        Getdata();
        setShowDeleteModal("none");
      }
      loader(false);
    });
  };

  var handleSearch = function (e) {
    var val = e.target.value;
    setFilter({ ...filters, search: val, page: 1 });
    clearTimeout(window._agreementSearchTimeout);
    window._agreementSearchTimeout = setTimeout(function () {
      Getdata({ search: val, page: 1 });
    }, 400);
  };

  var getStatusBadge = function (status) {
    var colors = {
      active: { bg: "#e6f7ee", color: "#389e6b" },
      inactive: { bg: "#fff1f0", color: "#cf1322" },
      draft: { bg: "#fff7e6", color: "#d48806" },
    };
    var style = colors[status] || colors.draft;
    return (
      <span
        style={{
          padding: "4px 12px",
          borderRadius: "12px",
          fontSize: "12px",
          fontWeight: 500,
          backgroundColor: style.bg,
          color: style.color,
          textTransform: "capitalize",
        }}
      >
        {status || "draft"}
      </span>
    );
  };

  var formatDate = function (dateStr) {
    if (!dateStr) return "-";
    var d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <Layout2 title="Agreement Templates" Sidetitle="Agreement Templates">
      <div className="mainareas new-table-set">
        <CommonDeleteModal
          show={ShowDeleteModal}
          setShow={setShowDeleteModal}
          confirm={Delete}
        />

        {/* Header */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
          <div className="bids-top mb-2 mb-sm-0">
            <h4>
              Results<span>{total}</span>
            </h4>
          </div>
          <a
            className="btn btn-primary py-2"
            onClick={function () { historyHook.push("/agreement-template/add"); }}
          >
            <i className="fas fa-plus-circle me-2"></i>
            Create New Template
          </a>
        </div>

        {/* Filters */}
        <div className="d-flex flex-wrap gap-3 mb-3">
          <div style={{ minWidth: "220px", flex: 1, maxWidth: "350px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search templates..."
              value={filters.search}
              onChange={handleSearch}
            />
          </div>
          <div>
            <select
              className="form-control"
              value={filters.status}
              onChange={function (e) {
                var val = e.target.value;
                setFilter({ ...filters, status: val, page: 1 });
                Getdata({ status: val, page: 1 });
              }}
            >
              {statusOptions.map(function (opt) {
                return (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        {/* Table */}
        <div className="table-responsive table_section new-table">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Version</th>
                <th scope="col">Status</th>
                <th scope="col">Last Updated</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>
            <tbody>
              {data?.map(function (itm, index) {
                return (
                  <tr key={itm.id || itm._id || index}>
                    <td>
                      <div className="user_detail">
                        <div className="user_name">
                          <h4
                            className="user"
                            title="Edit"
                            onClick={function () {
                              historyHook.push("/agreement-template/" + (itm.id || itm._id));
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {itm.name && itm.name.length > 50
                              ? itm.name.substr(0, 50) + "..."
                              : itm.name}
                          </h4>
                        </div>
                      </div>
                    </td>
                    <td>{itm.version || "1.0"}</td>
                    <td>{getStatusBadge(itm.status)}</td>
                    <td>{formatDate(itm.updatedAt || itm.updated_at)}</td>
                    <td>
                      <div className="action_icons">
                        <Tooltip placement="top" title="Edit">
                          <span
                            className="edit_icon pointer"
                            onClick={function () {
                              historyHook.push("/agreement-template/" + (itm.id || itm._id));
                            }}
                          >
                            <i className="material-icons pointer edit">edit</i>
                          </span>
                        </Tooltip>
                        <Tooltip placement="top" title="Delete">
                          <span
                            className="edit_icon pointer"
                            onClick={function () {
                              setShowDeleteModal("block");
                              setDeleteId(itm.id || itm._id);
                            }}
                          >
                            <i className="material-icons delete" title="Delete">
                              delete
                            </i>
                          </span>
                        </Tooltip>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Empty State */}
        {total === 0 && !loaderr ? (
          <div className="no-data">
            <img src="assets/img/no-data.png" alt="No data" />
            No Agreement Templates Found
          </div>
        ) : null}

        {/* Pagination */}
        {total > 0 ? (
          <div className="paginationWrapper gap-0">
            <div className="d-flex align-items-center mb-2 mb-sm-0">
              <div className="me-2 user-name-color">Show</div>
              {total > 0 && (
                <div className="dropdown addDropdown chnagesname">
                  <button
                    className="btn btn-primary dropdown-toggle removeBg"
                    type="button"
                    id="dropdownMenuButton"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {filters?.count}
                  </button>
                  <div
                    className="dropdown-menu shadow bg_hover"
                    aria-labelledby="dropdownMenuButton"
                  >
                    {[10, 20, 30, 50].map(function (n) {
                      return (
                        <a
                          key={n}
                          className="dropdown-item"
                          onClick={function () {
                            ChangeFilter({ ...filters, count: n, page: 1 });
                          }}
                        >
                          {n}
                        </a>
                      );
                    })}
                  </div>
                </div>
              )}
              <div className="ms-2 user-name-color">
                from {total} Templates
              </div>
            </div>
            <Pagination
              currentPage={filters.page}
              totalSize={total}
              sizePerPage={filters.count}
              changeCurrentPage={pageChange}
            />
          </div>
        ) : null}
      </div>
    </Layout2>
  );
};

export default AgreementTemplates;
